module.exports = __webpack_public_path__ + "static/media/2022-february-youtube.084143ec.jpg";